var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsdeColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0016 42.1C26.0016 42.5968 25.5984 43 25.1016 43V41.2C25.5984 41.2 26.0016 41.6032 26.0016 42.1Z",
    fill: "#0F5094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1016 42.1L25.4859 42.9163C25.4859 42.9163 39.1155 35.8063 41.7579 25H25.1016V42.1Z",
    fill: "#0F5094"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3016 14.2C41.7986 14.2 42.2016 13.7971 42.2016 13.3C42.2016 12.8029 41.7986 12.4 41.3016 12.4C40.8045 12.4 40.4016 12.8029 40.4016 13.3C40.4016 13.7971 40.8045 14.2 41.3016 14.2Z",
    fill: "#0883D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2016 13.3L41.3016 12.4C31.2918 12.4 31.1514 7 25.1016 7V25H41.7579C42.0414 23.8408 42.2016 22.6402 42.2016 21.4C42.2016 18.5704 42.2016 13.3 42.2016 13.3Z",
    fill: "#0883D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1031 43C24.6063 43 24.2031 42.5968 24.2031 42.1C24.2031 41.6032 24.6063 41.2 25.1031 41.2V43Z",
    fill: "#0370C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1094 42.1L24.7251 42.9163C24.7251 42.9163 11.0955 35.8063 8.45312 25H25.1094V42.1Z",
    fill: "#0370C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 14.1984C9.39706 14.1984 9.8 13.7955 9.8 13.2984C9.8 12.8014 9.39706 12.3984 8.9 12.3984C8.40294 12.3984 8 12.8014 8 13.2984C8 13.7955 8.40294 14.1984 8.9 14.1984Z",
    fill: "#33BFF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.3L8.9 12.4C18.9098 12.4 19.0502 7 25.1 7V25H8.4437C8.1602 23.8408 8 22.6402 8 21.4C8 18.5704 8 13.3 8 13.3Z",
    fill: "#33BFF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsdeColor);
export default __webpack_public_path__ + "static/media/msde_color.fd3c65e5cce693af51bf0c4eb6098ef7.svg";
export { ForwardRef as ReactComponent };